import script from "./VensoDeliveryView.vue?vue&type=script&setup=true&lang=ts"
export * from "./VensoDeliveryView.vue?vue&type=script&setup=true&lang=ts"

import "./VensoDeliveryView.vue?vue&type=style&index=0&id=0a32fa04&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a32fa04"]])

export default __exports__